import { Rating } from "@eb/shared";

/** Human label for a scheduling interval, used on the rating buttons. */
export function formatInterval(days: number, minutes: number): string {
    if (days >= 365) {
        const years = days / 365;
        return `${years >= 10 ? Math.round(years) : years.toFixed(1)} 年`;
    }
    if (days >= 30) return `${Math.round(days / 30)} 个月`;
    if (days >= 1) return `${days} 天`;
    if (minutes >= 60) return `${Math.round(minutes / 60)} 小时`;
    return `${minutes} 分钟`;
}

export const RATING_LABELS: Record<Rating, string> = {
    [Rating.Again]: "忘记了",
    [Rating.Hard]: "有点难",
    [Rating.Good]: "记得",
    [Rating.Easy]: "很简单"
};

/** Keyboard hint shown on each rating button. */
export const RATING_KEYS: Record<Rating, string> = {
    [Rating.Again]: "1",
    [Rating.Hard]: "2",
    [Rating.Good]: "3",
    [Rating.Easy]: "4"
};

export const CARD_STATE_LABELS: Record<string, string> = {
    NEW: "未学",
    LEARNING: "学习中",
    REVIEW: "复习中",
    RELEARNING: "重新学习"
};

export function formatPercent(value: number, digits = 0): string {
    return `${(value * 100).toFixed(digits)}%`;
}

/** "3 分 20 秒" style duration, for exam timers and session summaries. */
export function formatDuration(seconds: number): string {
    const safe = Math.max(0, Math.round(seconds));
    const minutes = Math.floor(safe / 60);
    const rest = safe % 60;
    if (minutes === 0) return `${rest} 秒`;
    return `${minutes} 分 ${rest} 秒`;
}

/** mm:ss countdown for the exam clock. */
export function formatClock(seconds: number): string {
    const safe = Math.max(0, Math.floor(seconds));
    const minutes = Math.floor(safe / 60);
    const rest = safe % 60;
    return `${String(minutes).padStart(2, "0")}:${String(rest).padStart(2, "0")}`;
}

/** Relative day description for a due date. */
export function formatDue(iso: string, now = new Date()): string {
    const due = new Date(iso);
    const deltaMs = due.getTime() - now.getTime();
    if (deltaMs <= 0) return "现在";

    const minutes = Math.round(deltaMs / 60_000);
    if (minutes < 60) return `${minutes} 分钟后`;
    const hours = Math.round(minutes / 60);
    if (hours < 24) return `${hours} 小时后`;
    const days = Math.round(hours / 24);
    if (days < 30) return `${days} 天后`;
    return `${Math.round(days / 30)} 个月后`;
}

export function formatDate(iso: string): string {
    return new Date(iso).toLocaleDateString("zh-CN", { year: "numeric", month: "2-digit", day: "2-digit" });
}

export function formatDateTime(iso: string): string {
    return new Date(iso).toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    });
}

/** A/B/C/D label for an option at a given index. */
export function optionLetter(index: number): string {
    return String.fromCharCode(65 + index);
}
